import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["enableResize", "className", "dimensions", "children", "containerRef", "resizingRef", "tooltipPosRef", "onFocusedChange", "handleMouseDown", "handleTouchStart"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import CursorTooltip from '@/components/CursorTooltip';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const handles = [{
  position: 'topLeft'
}, {
  position: 'topRight'
}, {
  position: 'bottomLeft'
}, {
  position: 'bottomRight'
}, {
  position: 'middleLeft'
}, {
  position: 'middleRight'
}, {
  position: 'middleTop'
}, {
  position: 'middleBottom'
}];

const ResizableContainer = _ref => {
  let {
    enableResize = false,
    className,
    dimensions,
    children,
    containerRef,
    resizingRef,
    tooltipPosRef,
    onFocusedChange,
    handleMouseDown,
    handleTouchStart
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    ref: containerRef,
    className: clsx(className, styles.container)
  }, typeof onFocusedChange === 'function' && {
    onMouseDown: () => onFocusedChange(true)
  }), props), {}, {
    children: [children, enableResize && handles.map((handle, indx) => {
      return /*#__PURE__*/_jsx(ResizeHandle, {
        active: resizingRef.current.position === handle.position,
        position: handle.position,
        onMouseDown: handleMouseDown,
        onTouchStart: handleTouchStart
      }, `${handle.position}-${indx}`);
    }), resizingRef.current.active && enableResize && !!dimensions ? /*#__PURE__*/_jsx(CursorTooltip, {
      text: `${dimensions.width} x ${dimensions.height}`,
      style: {
        left: tooltipPosRef.current.left,
        top: tooltipPosRef.current.top,
        right: tooltipPosRef.current.right,
        bottom: tooltipPosRef.current.bottom
      }
    }) : null]
  }));
};

const ResizeHandle = _ref2 => {
  let {
    active,
    position,
    onMouseDown,
    onTouchStart
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.handle, styles[`handle--${position}`], {
      [styles[`handle--active`]]: active
    }),
    onMouseDown: e => onMouseDown(e, position),
    onTouchStart: e => onTouchStart(e, position)
  });
};

export default ResizableContainer;